import {
    NumberInput,
    RemovableRow,
    StyleFunction,
    useThemedStyle,
} from "@venuepos/react-common";
import { GQViProductsQuery } from "graphql-sdk";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
    selectComponents,
    selectStyles,
} from "../../../components/multi-picker";
import { View } from "react-native";

export function ViPickerRow({
    data,
    onRemoveViProduct,
    onProductChange,
    index,
    productRelation,
}: {
    data: GQViProductsQuery;
    onRemoveViProduct: (index) => void;
    onProductChange: (
        index: number,
        viProductId: string,
        value: number,
        measurementUnitId?: string
    ) => void;
    index: number;
    productRelation;
}) {
    const styles = useThemedStyle(styleFunc);

    const [measurementUnits, setMeasurementUnits] = useState([]);
    const [viProduct, setViProduct] = useState<
        { label: string; name: string; id: string } | undefined
    >();
    const [measurementUnit, setMeasurementUnit] = useState<
        { label: string; name: string; id: string } | undefined
    >();
    const [value, setValue] = useState<number>();

    const [isDeleted, setIsDeleted] = useState(false);

    useEffect(() => {
        // Initial setup of states if this row shows an existing product relation
        if (productRelation.productId) {
            const viProd = data.viProducts.data.find(
                itr => itr.id === productRelation.productId
            );

            setViProduct({
                name: viProd.name,
                label: viProd.name,
                id: viProd.id,
            });

            const measurement = viProd.measurementUnit.find(
                itr => itr.id === productRelation.measurementUnitId
            );

            const measurements = viProd.measurementUnit.map(itr => {
                return {
                    label: itr.name,
                    name: itr.name,
                    id: itr.id,
                };
            });
            if (measurements) {
                setMeasurementUnits(measurements);
            }
            if (measurement) {
                setMeasurementUnit({
                    name: measurement.name,
                    label: measurement.name,
                    id: measurement.id,
                });
            }
            setValue(productRelation.value);

            setIsDeleted(productRelation.isDeleted);
        }
    }, [data.viProducts.data, productRelation]);

    return (
        <RemovableRow
            onRemove={() => {
                onRemoveViProduct(index);
            }}
            closePosition="top"
            style={[
                styles.removableRow,
                isDeleted ? styles.deletedRelation : undefined,
            ]}
        >
            <View style={styles.selectContainer}>
                <Select
                    // This must be set to avoid having the dropdown hidden by other inputs
                    menuPortalTarget={document.body}
                    options={[
                        {
                            options: data.viProducts.data
                                .filter(itr => itr.deletedAt === null)
                                .map(itr => {
                                    return {
                                        label: itr.name,
                                        name: itr.name,
                                        value: itr.id,
                                    };
                                }),
                        },
                    ]}
                    value={viProduct}
                    onChange={itm => {
                        setMeasurementUnit(null);
                        const viProd = data.viProducts.data.find(
                            // Typesystem does not think that values exist on item
                            itr => itr.id === (itm as any).value
                        );
                        if (viProd) {
                            onProductChange(
                                index,
                                viProd.id,
                                value,
                                measurementUnit?.id
                            );
                            const measurements = viProd.measurementUnit.map(
                                m => {
                                    return {
                                        label: m.name,
                                        name: m.name,
                                        id: m.id,
                                    };
                                }
                            );
                            if (measurements) {
                                setMeasurementUnits(measurements);
                            }
                        }
                    }}
                    styles={selectStyles}
                    components={selectComponents}
                />
            </View>
            <NumberInput
                onChange={val => {
                    setValue(val);
                    onProductChange(
                        index,
                        viProduct.id,
                        val,
                        measurementUnit?.id
                    );
                }}
                disabled={viProduct === undefined}
                value={productRelation.value}
            />
            <View style={styles.selectContainer}>
                <Select
                    // This must be set to avoid having the dropdown hidden by other inputs
                    menuPortalTarget={document.body}
                    onChange={itm => {
                        setMeasurementUnit(itm as any);
                        onProductChange(
                            index,
                            viProduct.id,
                            value,
                            (itm as any).id
                        );
                    }}
                    value={measurementUnit}
                    isSearchable={false}
                    options={measurementUnits}
                    styles={selectStyles}
                    components={selectComponents}
                    isDisabled={viProduct === undefined}
                />
            </View>
        </RemovableRow>
    );
}
const styleFunc: StyleFunction = theme => ({
    removableRow: {
        borderTopEndRadius: theme.borderRadiusTiny,
        borderBottomEndRadius: theme.borderRadiusTiny,
        zIndex: 1,
        paddingTop: 10,
        paddingLeft: 10,
    },
    deletedRelation: {
        backgroundColor: theme.colors.semiTransparentError,
    },
    selectContainer: { minWidth: 150, paddingHorizontal: 5 },
});
